<template>
  <div class="results" v-bind:class="{ iphone: iOS }">
    <div class="container">
      <div class="pt-3 pb-2 result-controls">
        <div class="w-xl-25 d-lg-inline-block mb-3 mb-xl-0">
          <DownloadResults></DownloadResults>
        </div>
        <div
          class="w-xl-75 d-lg-inline-block mr-auto mb-3 mb-lg-0"
          v-bind:class="{ 'float-xl-left': hebrew, 'float-xl-right': !hebrew }"
        >
          <div class="mb-3 d-md-inline-block mode-dd">
            <SelectMode></SelectMode>
          </div>
          <!--                 <div class="mb-3 d-md-inline-block view-dd"><SelectDisplay></SelectDisplay></div>
 -->
          <div class="d-lg-inline-block accuracy-slider">
            <SetAccuracy></SetAccuracy>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <Visualizer v-if="showVisualizer"></Visualizer>
      <FootnoteDisplay v-else></FootnoteDisplay>
    </div>
  </div>
</template>

<script>
import DownloadResults from "../components/DownloadResults"
import SelectMode from "../components/SelectMode"
//import SelectDisplay from "../components/SelectDisplay"
import FootnoteDisplay from "../components/FootnoteDisplay"
import Visualizer from "../components/Visualizer"
import SetAccuracy from "../components/SetAccuracy"

export default {
  name: "Results",
  components: {
    DownloadResults,
    SelectMode,
    // SelectDisplay,
    FootnoteDisplay,
    SetAccuracy,
    Visualizer,
  },
  data() {
    return {
      iOS: false,
    }
  },
  props: {},
  mounted: function () {
    document.body.classList.remove("search-focused")
    this.iOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  },
  computed: {
    showVisualizer: function () {
      return this.$store.state.visualizerView
    },
    hebrew() {
      return this.$settings.hebrew
    },
  },
}
</script>
<style>
.dicta-dropdown .col-auto {
  padding-left: 9px;
  padding-right: 9px;
}
</style>
<style scoped lang="scss">
.results {
  @media only screen and (max-width: 991px) {
    min-height: calc(100vh - 195px);
  }
  &.iphone {
    @media only screen and (max-width: 991px) {
      min-height: calc(100vh - 201px);
    }
  }
}
.result-controls {
  direction: ltr;
}
.he .result-controls {
  direction: rtl;
}
@media only screen and (min-width: 992px) {
  .mode-dd {
    width: 268px;
  }
  .he .mode-dd {
    width: 234px;
  }
  .w-md-25 {
    width: 25%;
  }
  .w-md-75 {
    width: 75%;
  }
  .mode-dd {
    // width: 185px;
    margin: 0 40px;
    position: relative;
    // &::before,
    &::after {
      content: "";
      height: 100%;
      position: absolute;
      width: 1px;
      background: #d8d8d8;
      left: -23px;
      top: 0;
    }
    &::before {
      right: -17px;
      left: auto;
    }
  }
}
.accuracy-slider {
  width: 335px;
  max-width: 100%;
}
</style>
